import React from 'react';
import { Globe, Lightbulb, BookOpen, CheckCircle } from 'lucide-react';
import EnhancedMarkdown, { MarkdownHeading } from './EnhancedMarkDown';

const SynthesisCard = ({ synthesis }) => {
  const sections = React.useMemo(() => {
    const content = synthesis.snippet;
    const parts = content.split(/\n/);
    
    return {
      introduction: parts[0] || '',
      mainContent: parts.slice(1, -1).join('\n\n') || '',
      conclusion: parts[parts.length - 1] || ''
    };
  }, [synthesis.snippet]);

  return (
    <div className="mb-8 rounded-xl overflow-hidden shadow-xl border border-gray-200">
      {/* Header */}
      <div className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 p-4">
        <div className="flex items-center gap-3">
          <Globe className="w-6 h-6 text-white" />
          <h3 className="text-lg font-semibold text-white">
            Synthèse des résultats
          </h3>
        </div>
      </div>

      {/* Content sections */}
      <div className="bg-white divide-y divide-gray-100">
        {/* Introduction */}
        <div className="p-6">
          <MarkdownHeading icon={Lightbulb} className="mb-3">
            <h4 className="text-lg font-medium text-gray-900">Introduction</h4>
            <div className="text-gray-600 mt-2">
              <EnhancedMarkdown content={sections.introduction} />
            </div>
          </MarkdownHeading>
        </div>

        {/* Main Content */}
        <div className="p-6">
          <MarkdownHeading icon={BookOpen} className="mb-3">
            <h4 className="text-lg font-medium text-gray-900">Points clés à retenir</h4>
            <div className="text-gray-600 mt-2">
              <EnhancedMarkdown content={sections.mainContent} />
            </div>
          </MarkdownHeading>
        </div>

        {/* Conclusion */}
        <div className="p-6">
          <MarkdownHeading icon={CheckCircle} className="mb-3">
            <h4 className="text-lg font-medium text-gray-900">Conclusion</h4>
            <div className="text-gray-600 mt-2">
              <EnhancedMarkdown content={sections.conclusion} />
            </div>
          </MarkdownHeading>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-50 p-4">
        <div className="flex items-center justify-between">
          <p className="text-sm text-gray-500 italic">
            Synthèse générée par Intelligence Artificielle pour faciliter votre apprentissage
          </p>
          <p className="text-xs text-gray-400">
            {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SynthesisCard;